/**
 * The app's one workout-settings store, over Capacitor Preferences
 * (`D209`), and the hook the screens read it with. Apart from
 * `workout-prefs.ts` because this file imports `src/native`; the Node tests
 * build their own store over a memory storage.
 */
import { useEffect } from "react";
import { useStore } from "zustand";
import { preferences } from "../../../native";
import {
  createWorkoutPrefsStore,
  type WorkoutPrefs,
  type WorkoutPrefsStore,
} from "./workout-prefs";

export const workoutPrefsStore: WorkoutPrefsStore = createWorkoutPrefsStore({
  getItem: (key) => preferences.get(key),
  setItem: (key, value) => preferences.set(key, value),
});

/** A slice of the settings; loads the stored value on first use. */
export function useWorkoutPrefs<T>(
  selector: (prefs: WorkoutPrefs) => T,
  given?: WorkoutPrefsStore
): T {
  const store = given ?? workoutPrefsStore;
  useEffect(() => {
    store.load().catch(() => undefined);
  }, [store]);
  return useStore(store, selector);
}

export {
  barCustomPatch,
  plateSetupOf,
  platesPatch,
  type RestSound,
  type RestVolume,
  WARMUP_REST_RANGE,
  type WarmupRoundingChoice,
  type WorkoutPrefs,
  type WorkoutPrefsStore,
} from "./workout-prefs";
